//import React, { useState, useEffect, useRef, useMemo } from 'react';
//import { Button, Input, Label } from '../../Shared';
//import { calculateEmbossCost } from '../../Functions.js/Embossing';
//import { calculateFoilingCost } from '../../Functions.js/Foiling';

//const presses = [
//    { name: 'Large Miller', minWidth: 26, minLength: 20, maxWidth: 40, maxLength: 28, piecesPerHour: 1200, perHourCost: 70, mrCost: 75 },
//    { name: 'Small Miller', minWidth: 20, minLength: 13, maxWidth: 28, maxLength: 20, piecesPerHour: 1800, perHourCost: 55, mrCost: 55 },
//    { name: 'Thompson', minWidth: 12, minLength: 9, maxWidth: 40, maxLength: 28, piecesPerHour: 500, perHourCost: 100, mrCost: 55 },
//    { name: 'Saroglia', minWidth: 12, minLength: 9, maxWidth: 28, maxLength: 20, piecesPerHour: 1200, perHourCost: 55, mrCost: 55 },
//    { name: 'Yawa', minWidth: 13, minLength: 10, maxWidth: 28, maxLength: 20, piecesPerHour: 1200, perHourCost: 55, mrCost: 55 },
//    { name: 'Large Kluge', minWidth: 15, minLength: 11, maxWidth: 21, maxLength: 13, piecesPerHour: 1500, perHourCost: 55, mrCost: 55 },
//    { name: 'Small Kluge', minWidth: 11, minLength: 8.5, maxWidth: 18, maxLength: 12, piecesPerHour: 1800, perHourCost: 55, mrCost: 55 },
//];

//const standardtwopocket = [
//    { quantity: 500, totalCost: 175 }, { quantity: 1000, totalCost: 200 }, { quantity: 1500, totalCost: 250 },
//    { quantity: 2000, totalCost: 300 }, { quantity: 2500, totalCost: 375 }, { quantity: 3000, totalCost: 400 },
//    { quantity: 3500, totalCost: 450 }, { quantity: 4000, totalCost: 500 }, { quantity: 4500, totalCost: 550 },
//    { quantity: 5000, totalCost: 575 }, { quantity: 5500, totalCost: 600 }, { quantity: 6000, totalCost: 650 },
//    { quantity: 6500, totalCost: 700 }, { quantity: 7000, totalCost: 750 }, { quantity: 7500, totalCost: 750 },
//    { quantity: 8000, totalCost: 800 }, { quantity: 8500, totalCost: 850 }, { quantity: 9000, totalCost: 900 },
//    { quantity: 9500, totalCost: 925 }, { quantity: 10000, totalCost: 925 }, { quantity: 12500, totalCost: 1125 },
//    { quantity: 15000, totalCost: 1275 }, { quantity: 17500, totalCost: 1488 }, { quantity: 20000, totalCost: 1600 },
//    { quantity: 22500, totalCost: 1800 }, { quantity: 25000, totalCost: 1815 }, { quantity: 50000, totalCost: 3250 },
//    { quantity: 75000, totalCost: 4650 }, { quantity: 100000, totalCost: 5800 }
//];

//const NumInput = React.forwardRef(({ value, onChange, placeholder, ...props }, ref) => {
//    const formatForDisplay = (val) => (val == null || val === '') ? '' : String(Number(val));
//    const handleChange = (e) => {
//        const rawValue = e.target.value;
//        if (rawValue === '') { onChange(null); return; }
//        const num = Number(rawValue);
//        if (!isNaN(num)) onChange(num);
//    };
//    return <Input ref={ref} type="number" value={formatForDisplay(value)} onChange={handleChange} placeholder={placeholder || "0"} {...props} />;
//});

//const getBestPress = (w, l, allowMiller = true) => {
//    if (!w || !l) return null;
//    const orientations = [{ grip: w, feed: l }, { grip: l, feed: w }];
//    let best = null;
//    let highestSpeed = 0;
//    for (const { grip, feed } of orientations) {
//        const valid = presses.filter(p =>
//            grip >= p.minWidth && grip <= p.maxWidth &&
//            feed >= p.minLength && feed <= p.maxLength &&
//            (allowMiller || !p.name.includes('Miller'))
//        );
//        if (valid.length > 0) {
//            const fastest = valid.reduce((a, b) => a.piecesPerHour > b.piecesPerHour ? a : b);
//            if (fastest.piecesPerHour > highestSpeed) {
//                highestSpeed = fastest.piecesPerHour;
//                best = fastest;
//            }
//        }
//    }
//    return best;
//};

//const PocketFolder = ({ closeModal, setEstitems, estitems = {}, editingItem }) => {
//    const [width, setWidth] = useState(editingItem?.width || 9);
//    const [length, setLength] = useState(editingItem?.length || 12);
//    const [numPockets, setNumPockets] = useState(editingItem?.numPockets || 2);
//    const [quantities, setQuantities] = useState(editingItem?.quantities || []);
//    const [selectedPress, setSelectedPress] = useState(editingItem?.press || '');
//    const quanbox = useRef(null);
//    const [dieCost, setDieCost] = useState(editingItem?.dieCost ?? 0);
//    const [dieMr, setDieMr] = useState(editingItem?.dieMr ?? 55);
//    const [singleFoldCount, setSingleFoldCount] = useState(editingItem?.singleFoldCount ?? 0);
//    const [box1Count, setBox1Count] = useState(editingItem?.box1Count ?? 0);
//    const [box2Count, setBox2Count] = useState(editingItem?.box2Count ?? 0);
//    const [stripping, setStripping] = useState(!!editingItem?.stripping);
//    const [numUp, setNumUp] = useState(editingItem?.numUp ?? 1);
//    const AUTO_FOLD_RATE = 30;
//    const [boxRate, setBoxRate] = useState({
//        rate: editingItem?.boxRate?.rate ?? 0,
//        override: editingItem?.boxRate?.override ?? null
//    });
//    const [foldingMode, setFoldingMode] = useState(editingItem?.foldingMode || 'none');
//    const [foldingCount, setFoldingCount] = useState(editingItem?.folding ?? 0);
//    const [emboss, setEmboss] = useState(editingItem?.emboss || {
//        state: false,
//        plates: [{
//            id: Date.now(),
//            plateWidth: 0, plateLength: 0,
//            pressWidth: 0, pressLength: 0,
//            platecost: 0, overridePlatecost: null,
//            mr: 50, overrideMr: null,
//            backer: 59, overrideBacker: null,
//            selectedPress: null, pressName: ''
//        }]
//    });
//    const [deboss, setDeboss] = useState(editingItem?.deboss || {
//        state: false,
//        plates: [{
//            id: Date.now(),
//            plateWidth: 0, plateLength: 0,
//            pressWidth: 0, pressLength: 0,
//            platecost: 0, overridePlatecost: null,
//            mr: 50, overrideMr: null,
//            backer: 59, overrideBacker: null,
//            selectedPress: null, pressName: ''
//        }]
//    });
//    const [foil, setFoil] = useState(editingItem?.foil || {
//        state: false,
//        mr: 50,
//        plates: [{
//            id: Date.now(),
//            plateWidth: 0, plateLength: 0,
//            pressWidth: 0, pressLength: 0,
//            platecost: 0, overridePlatecost: null,
//            color: '', passes: 1,
//            foilCost: null, overrideFoilCost: null,
//            selectedPress: null, pressName: ''
//        }]
//    });
//    const [matPercent, setMatPercent] = useState(editingItem?.matPercent ?? 1.30);
//    const mat = Number(matPercent) || 1.30;
//    const [labPercent, setLabPercent] = useState(editingItem?.labPercent ?? 1.15);
//    const lab = Number(labPercent) || 1.15;
//    const [glueTapingMode, setGlueTapingMode] = useState(editingItem?.glueTapingMode || 'auto');
//    const [pocketTabs, setPocketTabs] = useState(editingItem?.pocketTabs || {
//        pocket1: { height: 4, numTabs: 1 },
//        pocket2: { height: 4, numTabs: 1 }
//    });

//    const sizeIs9x12 = Number(width) === 9 && Number(length) === 12;
//    const pocket1HeightIs4 = Number(pocketTabs.pocket1.height) === 4;
//    const pocket2HeightIs4 = numPockets === 1 || Number(pocketTabs.pocket2?.height) === 4;

//    const isStandard9x12With4InchPockets = sizeIs9x12 && pocket1HeightIs4 && pocket2HeightIs4;

//    const needsSpecialFinish = emboss.state || deboss.state || foil.state;
//    const bestMainPress = useMemo(() => getBestPress(width, length, !needsSpecialFinish), [
//        width, length, needsSpecialFinish, emboss.state, deboss.state, foil.state
//    ]);

//    useEffect(() => {
//        if (!isStandard9x12With4InchPockets && bestMainPress && !selectedPress) {
//            setSelectedPress(bestMainPress.name);
//        }
//    }, [bestMainPress, selectedPress, isStandard9x12With4InchPockets]);

//    useEffect(() => {
//        const updatePress = (setter, state) => {
//            if (!state.state) return;
//            setter(prev => ({
//                ...prev,
//                plates: prev.plates.map(plate => {
//                    if (!plate.pressWidth || !plate.pressLength) return plate;
//                    const best = getBestPress(plate.pressWidth, plate.pressLength, false);
//                    if (best && best.name !== plate.pressName) {
//                        return { ...plate, selectedPress: best, pressName: best.name };
//                    }
//                    return plate;
//                })
//            }));
//        };
//        updatePress(setEmboss, emboss);
//        updatePress(setDeboss, deboss);
//        updatePress(setFoil, foil);
//    }, [
//        emboss.state, deboss.state, foil.state,
//        emboss.plates.map(p => `${p.pressWidth}-${p.pressLength}`).join('|'),
//        deboss.plates.map(p => `${p.pressWidth}-${p.pressLength}`).join('|'),
//        foil.plates.map(p => `${p.pressWidth}-${p.pressLength}`).join('|')
//    ]);

//    useEffect(() => {
//        if (!editingItem) {
//            setPocketTabs({
//                pocket1: { height: 4, numTabs: 1 },
//                pocket2: { height: 4, numTabs: 1 }
//            });
//        }
//    }, [editingItem]);

//    const addquan = (e) => {
//        if (e.key !== 'Enter') return;
//        const val = e.target.value.trim();
//        const qty = parseInt(val, 10);
//        if (isNaN(qty) || qty <= 0) return;
//        setQuantities(prev => {
//            if (prev.some(x => x.quantity === qty)) return prev;
//            return [...prev, { quantity: qty }].sort((a, b) => a.quantity - b.quantity);
//        });
//        e.target.value = '';
//        quanbox.current?.focus();
//    };

//    const removeQuantity = (qty) => setQuantities(prev => prev.filter(q => q.quantity !== qty));

//    const handleSubmit = () => {
//        if (quantities.length === 0) {
//            alert('Please add at least one quantity');
//            return;
//        }
//        const cleanPlates = (plates) => plates.map(p => ({
//            plateWidth: p.plateWidth,
//            plateLength: p.plateLength,
//            pressWidth: p.pressWidth,
//            pressLength: p.pressLength,
//            platecost: p.overridePlatecost ?? p.platecost,
//            mr: p.overrideMr ?? p.mr,
//            backer: p.overrideBacker ?? p.backer,
//            pressName: p.pressName || null,
//            color: p.color,
//            passes: p.passes,
//            foilCost: p.overrideFoilCost ?? p.foilCost
//        }));

//        const quantitiesWithTotal = quantities.map(q => {
//            const qty = q.quantity;
//            const totalPieces = qty * numUp;
//            let grandTotal;
//            const boxesPerThousand = Math.ceil(totalPieces / 1000);
//            const ratePerThousand = boxRate.override !== null ? boxRate.override : boxRate.rate;
//            let boxesCost = boxesPerThousand * ratePerThousand;

//            if (isStandard9x12With4InchPockets) {
//                const match = standardtwopocket.find(item => item.quantity === qty);
//                grandTotal = match ? match.totalCost : 0;
//            } else {
//                const mainPress = presses.find(p => p.name === selectedPress) || bestMainPress || null;
//                const mainRunHours = mainPress ? qty / mainPress.piecesPerHour : 0;
//                const mainRunCost = mainRunHours * (mainPress?.perHourCost || 0) * lab;

//                const calcSpecialRun = (state) => state.state ? state.plates.reduce((sum, plate) => {
//                    const press = plate.selectedPress || getBestPress(plate.pressWidth, plate.pressLength, false);
//                    if (!press) return sum;
//                    const hours = qty / press.piecesPerHour;
//                    const passes = state === foil ? (plate.passes || 1) : 1;
//                    return sum + hours * press.perHourCost * passes * lab;
//                }, 0) : 0;

//                const embossRun = calcSpecialRun(emboss);
//                const debossRun = calcSpecialRun(deboss);
//                const foilRun = calcSpecialRun(foil);

//                const foilMaterial = foil.state ? foil.plates.reduce((sum, p) => {
//                    if (!p.plateWidth || !p.plateLength) return sum;
//                    const res = calculateFoilingCost({ quantity: qty }, p.plateLength, p.plateWidth);
//                    return sum + (p.overrideFoilCost ?? res?.foil?.foilcost ?? 0);
//                }, 0) : 0;

//                const foilPlateAndMrCost = foil.state ? foil.plates.reduce((s, p) => s + (p.overridePlatecost ?? p.platecost), 0) + (foil.mr * lab * foil.plates.reduce((s, p) => s + (p.passes || 1), 0)) : 0;

//                const embossSetup = emboss.state ? emboss.plates.reduce((s, p) =>
//                    s + ((p.overridePlatecost ?? p.platecost) * mat) + ((p.overrideBacker ?? p.backer) * mat) + ((p.overrideMr ?? p.mr) * lab), 0) : 0;

//                const debossSetup = deboss.state ? deboss.plates.reduce((s, p) =>
//                    s + ((p.overridePlatecost ?? p.platecost) * mat) + ((p.overrideBacker ?? p.backer) * mat) + ((p.overrideMr ?? p.mr) * lab), 0) : 0;

//                const dieTotal = dieCost * mat;
//                const mrTotal = dieMr * lab;
//                const stripTotal = stripping ? Math.ceil(qty / 1000) * 6 : 0;
//                const foldingCost = foldingMode !== 'none' && foldingCount > 0
//                    ? Math.ceil(totalPieces / 1000) * (foldingMode === 'hand' ? 20 : AUTO_FOLD_RATE) * foldingCount
//                    : 0;

//                const singleFoldCost = singleFoldCount > 0 ? totalPieces * 0.01 * singleFoldCount : 0;
//                const box1Cost = box1Count > 0 ? totalPieces * 0.285 * box1Count : 0;
//                const box2Cost = box2Count > 0 ? totalPieces * 0.300 * box2Count : 0;

//                const totalTabs = (pocketTabs.pocket1.numTabs || 0) +
//                    (numPockets === 2 ? (pocketTabs.pocket2.numTabs || 0) : 0);

//                let glueCost = 0;
//                let glueLabel = '';

//                if (glueTapingMode === 'auto') {
//                    let totalInches = 0;
//                    if (pocketTabs.pocket1.height > 0 && pocketTabs.pocket1.numTabs > 0) {
//                        totalInches += pocketTabs.pocket1.height * pocketTabs.pocket1.numTabs;
//                    }
//                    if (numPockets === 2 && pocketTabs.pocket2.height > 0 && pocketTabs.pocket2.numTabs > 0) {
//                        totalInches += pocketTabs.pocket2.height * pocketTabs.pocket2.numTabs;
//                    }
//                    glueCost = totalInches > 0 ? (totalPieces / 1000) * totalInches * 0.01 * 1000 : 0;
//                    glueLabel = totalInches > 0 ? `Auto Glue (${totalInches.toFixed(2)}" total)` : '';
//                } else if (glueTapingMode === 'hand') {
//                    glueCost = totalTabs > 0 ? totalPieces * 0.09 * totalTabs : 0;
//                    glueLabel = totalTabs > 0 ? `Hand Glue (${totalTabs} tab${totalTabs > 1 ? 's' : ''} @ $0.09/ea)` : '';
//                } else if (glueTapingMode === 'taping') {
//                    glueCost = totalTabs > 0 ? totalPieces * 0.13 * totalTabs : 0;
//                    glueLabel = totalTabs > 0 ? `Taping (${totalTabs} tab${totalTabs > 1 ? 's' : ''} @ $0.13/ea)` : '';
//                }

//                grandTotal = mainRunCost + embossRun + debossRun + foilRun + foilMaterial + foilPlateAndMrCost +
//                    embossSetup + debossSetup + dieTotal + mrTotal + stripTotal +
//                    foldingCost + boxesCost + singleFoldCost + box1Cost + box2Cost + glueCost;
//            }

//            return {
//                ...q,
//                pricePerUnit: parseFloat((grandTotal / qty).toFixed(4)),
//                totalPrice: parseFloat(grandTotal.toFixed(2))
//            };
//        });

//        const newItem = {
//            id: editingItem?.id || Date.now(),
//            type: 'finishing',
//            width: Number(width),
//            length: Number(length),
//            numPockets,
//            press: isStandard9x12With4InchPockets ? null : selectedPress,
//            dieCost: dieCost === 0 ? null : dieCost,
//            dieMr: dieMr === 0 ? 0 : dieMr,
//            stripping,
//            size: `${width}" x ${length}"`,
//            singleFoldCount: Number(singleFoldCount) || 0,
//            box1Count: Number(box1Count) || 0,
//            box2Count: Number(box2Count) || 0,
//            numUp: Number(numUp) || 1,
//            boxRate: { rate: boxRate.rate, override: boxRate.override },
//            foldingMode,
//            folding: Number(foldingCount) || 0,
//            glueTapingMode,
//            labPercent: labPercent === 1.15 ? undefined : labPercent,
//            matPercent: matPercent === 1.30 ? undefined : matPercent,
//            emboss: emboss.state ? { ...emboss, plates: cleanPlates(emboss.plates) } : null,
//            deboss: deboss.state ? { ...deboss, plates: cleanPlates(deboss.plates) } : null,
//            foil: foil.state ? { ...foil, plates: cleanPlates(foil.plates) } : null,
//            pocketTabs: {
//                pocket1: {
//                    height: Number(pocketTabs.pocket1.height) || 0,
//                    numTabs: Number(pocketTabs.pocket1.numTabs) || 0
//                },
//                pocket2: numPockets === 2 ? {
//                    height: Number(pocketTabs.pocket2.height) || 0,
//                    numTabs: Number(pocketTabs.pocket2.numTabs) || 0
//                } : null
//            },
//            quantities: quantitiesWithTotal.map(q => ({
//                ...q,
//                totalPieces: q.quantity * (Number(numUp) || 1)
//            }))
//        };

//        setEstitems(prev => {
//            const updated = editingItem
//                ? prev.necc.map(i => i.id === editingItem.id ? newItem : i)
//                : [...(prev.necc || []), newItem];
//            return { ...prev, necc: updated };
//        });
//        closeModal();
//    };

//    return (
//        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/70" style={{ zIndex: '15000' }}>
//            <div className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-7xl mx-4 my-8 max-h-[90vh] overflow-y-auto p-8" style={{ padding: '20px' }}>
//                <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
//                    {editingItem ? 'Edit Finishing Item' : 'Add Finishing Item'}
//                </h2>
//                <div style={{ display: 'flex' }}>
//                    <div><Label>Add Quantity (press Enter)</Label><Input ref={quanbox} width="300px" type="number" placeholder="1000, 2500..." onKeyDown={addquan} /></div>
//                </div>
//                <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', marginTop: '20px', flexWrap: 'wrap' }}>
//                    <div>
//                        <Label>Width (inches)</Label><br />
//                        <NumInput width="120px" step="0.1" value={width} onChange={setWidth} placeholder="9" />
//                    </div>
//                    <div>
//                        <Label>Length (inches)</Label><br />
//                        <NumInput width="120px" step="0.1" value={length} onChange={setLength} placeholder="12" />
//                    </div>
//                    {!isStandard9x12With4InchPockets && (
//                        <div style={{ minWidth: '300px' }}>
//                            <Label>Press Machine</Label>
//                            <select value={selectedPress} onChange={e => setSelectedPress(e.target.value)}
//                                className={`w-full p-4 border-2 rounded-lg text-lg font-medium mt-2 ${selectedPress ? 'bg-green-50 border-green-500' : 'bg-red-50 border-red-500'}`}>
//                                <option value="" disabled>{width && length ? 'Select press...' : 'Enter size first'}</option>
//                                {presses.map(p => {
//                                    const fits = [width, length, length, width].some((gw, i) => {
//                                        const grip = i < 2 ? Number(width) : Number(length);
//                                        const feed = i < 2 ? Number(length) : Number(width);
//                                        return grip >= p.minWidth && grip <= p.maxWidth && feed >= p.minLength && feed <= p.maxLength;
//                                    });
//                                    const blocked = needsSpecialFinish && p.name.includes('Miller');
//                                    return (
//                                        <option key={p.name} value={p.name} disabled={!fits || blocked}>
//                                            {p.name}{bestMainPress?.name === p.name ? ' (RECOMMENDED)' : ''}{blocked ? ' (No special finish)' : ''}
//                                        </option>
//                                    );
//                                })}
//                            </select>
//                            {bestMainPress && !selectedPress && (
//                                <p className="text-sm text-green-600 mt-2">Auto-selected: {bestMainPress.name}</p>
//                            )}
//                        </div>
//                    )}
//                    <div>
//                        <Label>Pockets</Label><br />
//                        <select value={numPockets} onChange={(e) => setNumPockets(Number(e.target.value))}
//                            className="p-4 border-2 rounded-lg text-lg font-medium" style={{ width: "120px" }}>
//                            <option value={1}>1 Pocket</option>
//                            <option value={2}>2 Pockets</option>
//                        </select>
//                    </div>
//                    <div><Label>Die Cost $</Label><br /><NumInput width="100px" step="0.01" value={dieCost} onChange={setDieCost} placeholder="0.00" /></div>
//                    <div><span className="text-sm font-medium whitespace-nowrap">MR $</span><br /><NumInput value={dieMr} onChange={setDieMr} width="100px" /></div>
//                </div>
//                <div className="space-y-8">
//                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", justifyContent: "space-between", marginBottom: '20px', marginTop: '20px', gap: '20px' }}>
//                        <div className="flex flex-col gap-4" style={{ marginRight: '16px' }}>
//                            <div className="bg-gray-100 p-4 rounded-lg">
//                                <strong className="block mb-2 text-sm font-bold text-gray-700">Pocket Tabs</strong>
//                                <div className="grid grid-cols-2 gap-4">
//                                    <div>
//                                        <span className="text-sm font-medium">Pocket 1 Height (in)</span><br />
//                                        <NumInput value={pocketTabs.pocket1.height} onChange={v => setPocketTabs(prev => ({
//                                            ...prev,
//                                            pocket1: { ...prev.pocket1, height: v }
//                                        }))} step="0.1" min="0" width="100px" />
//                                    </div>
//                                    <div>
//                                        <span className="text-sm font-medium">Pocket 1 Tabs</span><br />
//                                        <NumInput value={pocketTabs.pocket1.numTabs} onChange={v => setPocketTabs(prev => ({
//                                            ...prev,
//                                            pocket1: { ...prev.pocket1, numTabs: Math.max(1, v || 1) }
//                                        }))} min="1" width="100px" />
//                                    </div>
//                                    {numPockets === 2 && (
//                                        <>
//                                            <div>
//                                                <span className="text-sm font-medium">Pocket 2 Height (in)</span><br />
//                                                <NumInput value={pocketTabs.pocket2.height} onChange={v => setPocketTabs(prev => ({
//                                                    ...prev,
//                                                    pocket2: { ...prev.pocket2, height: v }
//                                                }))} step="0.1" min="0" width="100px" />
//                                            </div>
//                                            <div>
//                                                <span className="text-sm font-medium">Pocket 2 Tabs</span><br />
//                                                <NumInput value={pocketTabs.pocket2.numTabs} onChange={v => setPocketTabs(prev => ({
//                                                    ...prev,
//                                                    pocket2: { ...prev.pocket2, numTabs: Math.max(1, v || 1) }
//                                                }))} min="1" width="100px" />
//                                            </div>
//                                        </>
//                                    )}
//                                </div>
//                                <div className="mt-4">
//                                    <span className="text-sm font-medium whitespace-nowrap">Glue / Taping Type</span><br />
//                                    <select
//                                        value={glueTapingMode}
//                                        onChange={e => setGlueTapingMode(e.target.value)}
//                                        className="w-full px-3 py-2 border rounded text-sm mt-1"
//                                    >
//                                        <option value="auto">Auto Glue</option>
//                                        <option value="hand">Hand Glue</option>
//                                        <option value="taping">Taping</option>
//                                    </select>
//                                </div>
//                            </div>
//                        </div>
//                        <div className="flex flex-wrap items-center gap-10" style={{ paddingTop: '15px' }}>
//                            <div className="items-center gap-3">
//                                <span className="text-sm font-medium whitespace-nowrap">Single Fold (#)</span><br />
//                                <NumInput value={singleFoldCount} onChange={setSingleFoldCount} min="0" width="80px" placeholder="0" />
//                            </div>
//                            <div className="items-center gap-3">
//                                <span className="text-sm font-medium whitespace-nowrap">1 Box (#)</span><br />
//                                <NumInput value={box1Count} onChange={setBox1Count} min="0" width="80px" placeholder="0" />
//                            </div>
//                            <div className="items-center gap-3">
//                                <span className="text-sm font-medium whitespace-nowrap">2 Box (#)</span><br />
//                                <NumInput value={box2Count} onChange={setBox2Count} min="0" width="80px" placeholder="0" />
//                            </div>
//                            <div className="items-center"><span className="text-sm font-medium whitespace-nowrap">Num Up:</span><br /><NumInput value={numUp} onChange={setNumUp} min="1" width="100px" /></div>
//                            <div><label className="flex items-center gap-3"><input type="checkbox" checked={stripping} onChange={e => setStripping(e.target.checked)} className="w-5 h-5" /><span>Stripping</span></label></div>
//                            <div>
//                                <span className="text-sm font-medium whitespace-nowrap">Boxes :</span><br />
//                                <div className="flex items-center gap-2">
//                                    <strong className={boxRate.override === null ? "text-green-600" : "text-orange-600"}>
//                                        ${boxRate.override !== null ? boxRate.override.toFixed(2) : boxRate.rate.toFixed(2)}/k
//                                    </strong>
//                                    <NumInput
//                                        value={boxRate.override ?? ''}
//                                        onChange={(v) => setBoxRate(prev => ({ ...prev, override: v === '' || v === null ? null : parseFloat(v) }))}
//                                        step="0.01"
//                                        placeholder="Override rate"
//                                        width="90px"
//                                        className="text-orange-600 font-medium"
//                                    />
//                                </div>
//                            </div>
//                        </div>
//                    </div>

//                    {/* EMBOSSING, DEBOSSING, FOIL STAMPING - unchanged from previous full version */}
//                    {quantities.length > 0 && (
//                        <div className="mt-10">
//                            <h2 className="text-2xl font-bold text-gray-800 mb-5">Quantities & Pricing</h2>
//                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-6">
//                                {quantities.map(item => {
//                                    const qty = item.quantity;
//                                    const totalPieces = qty * numUp;
//                                    let mainRunCost = 0, embossRun = 0, debossRun = 0, foilRun = 0, foilMaterial = 0, foilPlateAndMrCost = 0;
//                                    let embossSetup = 0, debossSetup = 0, dieTotal = 0, mrTotal = 0, stripTotal = 0;
//                                    let foldingCost = 0, boxesCost = 0;
//                                    let singleFoldCost = 0, box1Cost = 0, box2Cost = 0, glueCost = 0;
//                                    let glueLabel = '';
//                                    let grandTotal = 0;
//                                    let boxesPerThousand = Math.ceil(totalPieces / 1000);
//                                    let ratePerThousand = boxRate.override !== null ? boxRate.override : boxRate.rate;

//                                    if (isStandard9x12With4InchPockets) {
//                                        const match = standardtwopocket.find(m => m.quantity === qty);
//                                        grandTotal = match ? match.totalCost : 0;
//                                    } else {
//                                        const mainPress = presses.find(p => p.name === selectedPress) || bestMainPress || null;
//                                        const mainRunHours = mainPress ? qty / mainPress.piecesPerHour : 0;
//                                        mainRunCost = mainRunHours * (mainPress?.perHourCost || 0) * lab;

//                                        const calcSpecialRun = (state) => state.state ? state.plates.reduce((sum, plate) => {
//                                            const press = plate.selectedPress || getBestPress(plate.pressWidth, plate.pressLength, false);
//                                            if (!press) return sum;
//                                            const hours = qty / press.piecesPerHour;
//                                            const passes = state === foil ? (plate.passes || 1) : 1;
//                                            return sum + hours * press.perHourCost * passes * lab;
//                                        }, 0) : 0;

//                                        embossRun = calcSpecialRun(emboss);
//                                        debossRun = calcSpecialRun(deboss);
//                                        foilRun = calcSpecialRun(foil);

//                                        foilMaterial = foil.state ? foil.plates.reduce((sum, p) => {
//                                            if (!p.plateWidth || !p.plateLength) return sum;
//                                            const res = calculateFoilingCost({ quantity: qty }, p.plateLength, p.plateWidth);
//                                            return sum + (p.overrideFoilCost ?? res?.foil?.foilcost ?? 0);
//                                        }, 0) : 0;

//                                        foilPlateAndMrCost = foil.state ? foil.plates.reduce((s, p) => s + (p.overridePlatecost ?? p.platecost), 0) + (foil.mr * lab * foil.plates.reduce((s, p) => s + (p.passes || 1), 0)) : 0;

//                                        embossSetup = emboss.state ? emboss.plates.reduce((s, p) =>
//                                            s + ((p.overridePlatecost ?? p.platecost) * mat) + ((p.overrideBacker ?? p.backer) * mat) + ((p.overrideMr ?? p.mr) * lab), 0) : 0;

//                                        debossSetup = deboss.state ? deboss.plates.reduce((s, p) =>
//                                            s + ((p.overridePlatecost ?? p.platecost) * mat) + ((p.overrideBacker ?? p.backer) * mat) + ((p.overrideMr ?? p.mr) * lab), 0) : 0;

//                                        dieTotal = dieCost * mat;
//                                        mrTotal = dieMr * lab;
//                                        stripTotal = stripping ? Math.ceil(qty / 1000) * 6 : 0;
//                                        foldingCost = foldingMode !== 'none' && foldingCount > 0
//                                            ? Math.ceil(totalPieces / 1000) * (foldingMode === 'hand' ? 20 : AUTO_FOLD_RATE) * foldingCount
//                                            : 0;
//                                        boxesCost = boxesPerThousand * ratePerThousand;

//                                        singleFoldCost = singleFoldCount > 0 ? totalPieces * 0.01 * singleFoldCount : 0;
//                                        box1Cost = box1Count > 0 ? totalPieces * 0.285 * box1Count : 0;
//                                        box2Cost = box2Count > 0 ? totalPieces * 0.300 * box2Count : 0;

//                                        const totalTabs = (pocketTabs.pocket1.numTabs || 0) +
//                                            (numPockets === 2 ? (pocketTabs.pocket2.numTabs || 0) : 0);

//                                        if (glueTapingMode === 'auto') {
//                                            let totalInches = 0;
//                                            if (pocketTabs.pocket1.height > 0 && pocketTabs.pocket1.numTabs > 0) {
//                                                totalInches += pocketTabs.pocket1.height * pocketTabs.pocket1.numTabs;
//                                            }
//                                            if (numPockets === 2 && pocketTabs.pocket2.height > 0 && pocketTabs.pocket2.numTabs > 0) {
//                                                totalInches += pocketTabs.pocket2.height * pocketTabs.pocket2.numTabs;
//                                            }
//                                            glueCost = totalInches > 0 ? (totalPieces / 1000) * totalInches * 0.01 * 1000 : 0;
//                                            glueLabel = totalInches > 0 ? `Auto Glue (${totalInches.toFixed(2)}" total)` : '';
//                                        } else if (glueTapingMode === 'hand') {
//                                            glueCost = totalTabs > 0 ? totalPieces * 0.09 * totalTabs : 0;
//                                            glueLabel = totalTabs > 0 ? `Hand Glue (${totalTabs} tab${totalTabs > 1 ? 's' : ''} @ $0.09/ea)` : '';
//                                        } else if (glueTapingMode === 'taping') {
//                                            glueCost = totalTabs > 0 ? totalPieces * 0.13 * totalTabs : 0;
//                                            glueLabel = totalTabs > 0 ? `Taping (${totalTabs} tab${totalTabs > 1 ? 's' : ''} @ $0.13/ea)` : '';
//                                        }

//                                        grandTotal = mainRunCost + embossRun + debossRun + foilRun + foilMaterial + foilPlateAndMrCost +
//                                            embossSetup + debossSetup + dieTotal + mrTotal + stripTotal +
//                                            foldingCost + boxesCost + singleFoldCost + box1Cost + box2Cost + glueCost;
//                                    }

//                                    return (
//                                        <div key={item.quantity} className="border rounded-xl p-5 bg-white shadow-lg relative" style={{ padding: '10px' }}>
//                                            <button onClick={() => removeQuantity(item.quantity)} className="absolute top-2 right-2 bg-red-500 text-white w-7 h-7 rounded-full text-sm">X</button>
//                                            <div className="text-2xl font-bold text-blue-700">{item.quantity.toLocaleString()}</div>
//                                            {isStandard9x12With4InchPockets && <div className="text-green-600 font-bold text-sm mb-2">Standard 9x12 4" Pocket Pricing</div>}
//                                            <div className="text-sm text-gray-600">{selectedPress || (bestMainPress?.name || 'No press')}</div>
//                                            <div className="mt-4 space-y-1 text-sm">
//                                                {!isStandard9x12With4InchPockets && mainRunCost > 0 && <div className="flex justify-between"><span>Machine Run:</span><strong>${mainRunCost.toFixed(2)}</strong></div>}
//                                                {embossRun > 0 && <div className="flex justify-between text-purple-600"><span>Emboss Run:</span><strong>${embossRun.toFixed(2)}</strong></div>}
//                                                {debossRun > 0 && <div className="flex justify-between text-red-600"><span>Deboss Run:</span><strong>${debossRun.toFixed(2)}</strong></div>}
//                                                {foilRun > 0 && <div className="flex justify-between text-amber-700"><span>Foil Run:</span><strong>${foilRun.toFixed(2)}</strong></div>}
//                                                {foilMaterial > 0 && <div className="flex justify-between text-amber-600"><span>Foil Material:</span><strong>${foilMaterial.toFixed(2)}</strong></div>}
//                                                {foilPlateAndMrCost > 0 && <div className="flex justify-between text-amber-600"><span>Foil Plates + MR:</span><strong>${foilPlateAndMrCost.toFixed(2)}</strong></div>}
//                                                {embossSetup > 0 && <div className="flex justify-between text-blue-600"><span>Emboss Setup:</span><strong>${embossSetup.toFixed(2)}</strong></div>}
//                                                {debossSetup > 0 && <div className="flex justify-between text-red-600"><span>Deboss Setup:</span><strong>${debossSetup.toFixed(2)}</strong></div>}
//                                                {dieTotal > 0 && <div className="flex justify-between"><span>Die:</span><strong>${dieTotal.toFixed(2)}</strong></div>}
//                                                {mrTotal > 0 && <div className="flex justify-between"><span>MR:</span><strong>${mrTotal.toFixed(2)}</strong></div>}
//                                                {stripTotal > 0 && <div className="flex justify-between"><span>Stripping:</span><strong>${stripTotal.toFixed(2)}</strong></div>}
//                                                {foldingCost > 0 && <div className="flex justify-between text-indigo-600"><span>{foldingMode === 'hand' ? 'Hand' : 'Auto'} Folding:</span><strong>${foldingCost.toFixed(2)}</strong></div>}
//                                                {boxesCost > 0 && <div className="flex justify-between text-orange-600 font-medium"><span>Boxes ({boxesPerThousand} × ${ratePerThousand.toFixed(2)}/k):</span><strong>${boxesCost.toFixed(2)}</strong></div>}
//                                                {singleFoldCount > 0 && singleFoldCost > 0 && <div className="flex justify-between text-teal-600"><span>Single Fold ({singleFoldCount} @ $0.01/ea):</span><strong>${singleFoldCost.toFixed(2)}</strong></div>}
//                                                {box1Count > 0 && box1Cost > 0 && <div className="flex justify-between text-teal-600"><span>1 Box ({box1Count} @ $0.285/ea):</span><strong>${box1Cost.toFixed(2)}</strong></div>}
//                                                {box2Count > 0 && box2Cost > 0 && <div className="flex justify-between text-teal-600"><span>2 Box ({box2Count} @ $0.300/ea):</span><strong>${box2Cost.toFixed(2)}</strong></div>}
//                                                {glueCost > 0 && glueLabel && (
//                                                    <div className="flex justify-between text-teal-600">
//                                                        <span>{glueLabel}:</span>
//                                                        <strong>${glueCost.toFixed(2)}</strong>
//                                                    </div>
//                                                )}
//                                            </div>
//                                            <div className="border-t-2 border-gray-300 my-3"></div>
//                                            <div className="text-xl font-bold text-green-600">Total: ${grandTotal.toFixed(2)}</div>
//                                            <div className="text-lg font-bold text-green-600">Total Pieces: {(qty * numUp).toLocaleString()}</div>
//                                            <div className="text-sm text-gray-600">${(grandTotal / qty).toFixed(4)}/unit</div>
//                                        </div>
//                                    );
//                                })}
//                            </div>
//                        </div>
//                    )}


//                    <div className="mt-12 flex justify-end gap-4" style={{ marginTop: '30px' }}>
//                        <Button onClick={handleSubmit} disabled={quantities.length === 0} className="px-10 py-4 text-xl font-bold bg-blue-600 hover:bg-blue-700 text-white">
//                            {editingItem ? 'Update Item' : 'Add to Estimate'}
//                        </Button>
//                        <Button onClick={closeModal} variant="secondary" className="px-8 py-4 text-xl">Cancel</Button>
//                    </div>
//                </div>
//            </div>
//        </div>
//    );
//};

//export default PocketFolder;






import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Button, Input, Label } from '../../Shared';
import { calculateEmbossCost } from '../../Functions.js/Embossing';
import { calculateFoilingCost } from '../../Functions.js/Foiling';

const presses = [
    { name: 'Large Miller', minWidth: 26, minLength: 20, maxWidth: 40, maxLength: 28, piecesPerHour: 1200, perHourCost: 70, mrCost: 75 },
    { name: 'Small Miller', minWidth: 20, minLength: 13, maxWidth: 28, maxLength: 20, piecesPerHour: 1800, perHourCost: 55, mrCost: 55 },
    { name: 'Thompson', minWidth: 12, minLength: 9, maxWidth: 40, maxLength: 28, piecesPerHour: 500, perHourCost: 100, mrCost: 55 },
    { name: 'Saroglia', minWidth: 12, minLength: 9, maxWidth: 28, maxLength: 20, piecesPerHour: 1200, perHourCost: 55, mrCost: 55 },
    { name: 'Yawa', minWidth: 13, minLength: 10, maxWidth: 28, maxLength: 20, piecesPerHour: 1200, perHourCost: 55, mrCost: 55 },
    { name: 'Large Kluge', minWidth: 15, minLength: 11, maxWidth: 21, maxLength: 13, piecesPerHour: 1500, perHourCost: 55, mrCost: 55 },
    { name: 'Small Kluge', minWidth: 11, minLength: 8.5, maxWidth: 18, maxLength: 12, piecesPerHour: 1800, perHourCost: 55, mrCost: 55 },
];

const standardtwopocket = [
    { quantity: 500, totalCost: 175 }, { quantity: 1000, totalCost: 200 }, { quantity: 1500, totalCost: 250 },
    { quantity: 2000, totalCost: 300 }, { quantity: 2500, totalCost: 375 }, { quantity: 3000, totalCost: 400 },
    { quantity: 3500, totalCost: 450 }, { quantity: 4000, totalCost: 500 }, { quantity: 4500, totalCost: 550 },
    { quantity: 5000, totalCost: 575 }, { quantity: 5500, totalCost: 600 }, { quantity: 6000, totalCost: 650 },
    { quantity: 6500, totalCost: 700 }, { quantity: 7000, totalCost: 750 }, { quantity: 7500, totalCost: 750 },
    { quantity: 8000, totalCost: 800 }, { quantity: 8500, totalCost: 850 }, { quantity: 9000, totalCost: 900 },
    { quantity: 9500, totalCost: 925 }, { quantity: 10000, totalCost: 925 }, { quantity: 12500, totalCost: 1125 },
    { quantity: 15000, totalCost: 1275 }, { quantity: 17500, totalCost: 1488 }, { quantity: 20000, totalCost: 1600 },
    { quantity: 22500, totalCost: 1800 }, { quantity: 25000, totalCost: 1815 }, { quantity: 50000, totalCost: 3250 },
    { quantity: 75000, totalCost: 4650 }, { quantity: 100000, totalCost: 5800 }
];

const NumInput = React.forwardRef(({ value, onChange, placeholder, ...props }, ref) => {
    const formatForDisplay = (val) => (val == null || val === '') ? '' : String(Number(val));
    const handleChange = (e) => {
        const rawValue = e.target.value;
        if (rawValue === '') { onChange(null); return; }
        const num = Number(rawValue);
        if (!isNaN(num)) onChange(num);
    };
    return <Input ref={ref} type="number" value={formatForDisplay(value)} onChange={handleChange} placeholder={placeholder || "0"} {...props} />;
});

const getBestPress = (w, l, allowMiller = true) => {
    if (!w || !l) return null;
    const orientations = [{ grip: w, feed: l }, { grip: l, feed: w }];
    let best = null;
    let highestSpeed = 0;
    for (const { grip, feed } of orientations) {
        const valid = presses.filter(p =>
            grip >= p.minWidth && grip <= p.maxWidth &&
            feed >= p.minLength && feed <= p.maxLength &&
            (allowMiller || !p.name.includes('Miller'))
        );
        if (valid.length > 0) {
            const fastest = valid.reduce((a, b) => a.piecesPerHour > b.piecesPerHour ? a : b);
            if (fastest.piecesPerHour > highestSpeed) {
                highestSpeed = fastest.piecesPerHour;
                best = fastest;
            }
        }
    }
    return best;
};

const PocketFolder = ({ closeModal, setEstitems, estitems = {}, editingItem }) => {
    const [width, setWidth] = useState(editingItem?.width || 9);
    const [length, setLength] = useState(editingItem?.length || 12);
    const [numPockets, setNumPockets] = useState(editingItem?.numPockets || 2);
    const [quantities, setQuantities] = useState(editingItem?.quantities || []);
    const [selectedPress, setSelectedPress] = useState(editingItem?.press || '');
    const quanbox = useRef(null);
    const [dieCost, setDieCost] = useState(editingItem?.dieCost ?? 0);
    const [dieMr, setDieMr] = useState(editingItem?.dieMr ?? 55);
    const [singleFoldCount, setSingleFoldCount] = useState(editingItem?.singleFoldCount ?? 0);
    const [box1Count, setBox1Count] = useState(editingItem?.box1Count ?? 0);
    const [box2Count, setBox2Count] = useState(editingItem?.box2Count ?? 0);
    const [stripping, setStripping] = useState(!!editingItem?.stripping);
    const [numUp, setNumUp] = useState(editingItem?.numUp ?? 1);
    const AUTO_FOLD_RATE = 30;
    const [boxRate, setBoxRate] = useState({
        rate: editingItem?.boxRate?.rate ?? 0,
        override: editingItem?.boxRate?.override ?? null
    });
    const [foldingMode, setFoldingMode] = useState(editingItem?.foldingMode || 'none');
    const [foldingCount, setFoldingCount] = useState(editingItem?.folding ?? 0);
    const [emboss, setEmboss] = useState(editingItem?.emboss || {
        state: false,
        plates: [{
            id: Date.now(),
            plateWidth: 0, plateLength: 0,
            pressWidth: 0, pressLength: 0,
            platecost: 0, overridePlatecost: null,
            mr: 50, overrideMr: null,
            backer: 59, overrideBacker: null,
            selectedPress: null, pressName: ''
        }]
    });
    const [deboss, setDeboss] = useState(editingItem?.deboss || {
        state: false,
        plates: [{
            id: Date.now(),
            plateWidth: 0, plateLength: 0,
            pressWidth: 0, pressLength: 0,
            platecost: 0, overridePlatecost: null,
            mr: 50, overrideMr: null,
            backer: 59, overrideBacker: null,
            selectedPress: null, pressName: ''
        }]
    });
    const [foil, setFoil] = useState(editingItem?.foil || {
        state: false,
        mr: 50,
        plates: [{
            id: Date.now(),
            plateWidth: 0, plateLength: 0,
            pressWidth: 0, pressLength: 0,
            platecost: 0, overridePlatecost: null,
            color: '', passes: 1,
            foilCost: null, overrideFoilCost: null,
            selectedPress: null, pressName: ''
        }]
    });
    const [matPercent, setMatPercent] = useState(editingItem?.matPercent ?? 1.30);
    const mat = Number(matPercent) || 1.30;
    const [labPercent, setLabPercent] = useState(editingItem?.labPercent ?? 1.15);
    const lab = Number(labPercent) || 1.15;
    const [glueTapingMode, setGlueTapingMode] = useState(editingItem?.glueTapingMode || 'auto');
    const [pocketTabs, setPocketTabs] = useState(editingItem?.pocketTabs || {
        pocket1: { height: 4, numTabs: 1 },
        pocket2: { height: 4, numTabs: 1 }
    });

    const sizeIs9x12 = Number(width) === 9 && Number(length) === 12;
    const pocket1HeightIs4 = Number(pocketTabs.pocket1.height) === 4;
    const pocket2HeightIs4 = numPockets === 1 || Number(pocketTabs.pocket2?.height) === 4;

    const isStandard9x12With4InchPockets = sizeIs9x12 && pocket1HeightIs4 && pocket2HeightIs4;

    const needsSpecialFinish = emboss.state || deboss.state || foil.state;
    const bestMainPress = useMemo(() => getBestPress(width, length, !needsSpecialFinish), [
        width, length, needsSpecialFinish, emboss.state, deboss.state, foil.state
    ]);

    useEffect(() => {
        if (!isStandard9x12With4InchPockets && bestMainPress && !selectedPress) {
            setSelectedPress(bestMainPress.name);
        }
    }, [bestMainPress, selectedPress, isStandard9x12With4InchPockets]);

    useEffect(() => {
        const updatePress = (setter, state) => {
            if (!state.state) return;
            setter(prev => ({
                ...prev,
                plates: prev.plates.map(plate => {
                    if (!plate.pressWidth || !plate.pressLength) return plate;
                    const best = getBestPress(plate.pressWidth, plate.pressLength, false);
                    if (best && best.name !== plate.pressName) {
                        return { ...plate, selectedPress: best, pressName: best.name };
                    }
                    return plate;
                })
            }));
        };
        updatePress(setEmboss, emboss);
        updatePress(setDeboss, deboss);
        updatePress(setFoil, foil);
    }, [
        emboss.state, deboss.state, foil.state,
        emboss.plates.map(p => `${p.pressWidth}-${p.pressLength}`).join('|'),
        deboss.plates.map(p => `${p.pressWidth}-${p.pressLength}`).join('|'),
        foil.plates.map(p => `${p.pressWidth}-${p.pressLength}`).join('|')
    ]);

    useEffect(() => {
        if (!editingItem) {
            setPocketTabs({
                pocket1: { height: 4, numTabs: 1 },
                pocket2: { height: 4, numTabs: 1 }
            });
        }
    }, [editingItem]);

    const addquan = (e) => {
        if (e.key !== 'Enter') return;
        const val = e.target.value.trim();
        const qty = parseInt(val, 10);
        if (isNaN(qty) || qty <= 0) return;
        setQuantities(prev => {
            if (prev.some(x => x.quantity === qty)) return prev;
            return [...prev, { quantity: qty }].sort((a, b) => a.quantity - b.quantity);
        });
        e.target.value = '';
        quanbox.current?.focus();
    };

    const removeQuantity = (qty) => setQuantities(prev => prev.filter(q => q.quantity !== qty));

    const handleSubmit = () => {
        if (quantities.length === 0) {
            alert('Please add at least one quantity');
            return;
        }
        const cleanPlates = (plates) => plates.map(p => ({
            plateWidth: p.plateWidth,
            plateLength: p.plateLength,
            pressWidth: p.pressWidth,
            pressLength: p.pressLength,
            platecost: p.overridePlatecost ?? p.platecost,
            mr: p.overrideMr ?? p.mr,
            backer: p.overrideBacker ?? p.backer,
            pressName: p.pressName || null,
            color: p.color,
            passes: p.passes,
            foilCost: p.overrideFoilCost ?? p.foilCost
        }));

        const quantitiesWithTotal = quantities.map(q => {
            const qty = q.quantity;
            const totalPieces = qty * numUp;
            let grandTotal = 0;
            const boxesPerThousand = Math.ceil(totalPieces / 1000);
            const ratePerThousand = boxRate.override !== null ? boxRate.override : boxRate.rate;
            const boxesCost = boxesPerThousand * ratePerThousand;

            if (isStandard9x12With4InchPockets) {
                const match = standardtwopocket.find(item => item.quantity === qty);
                grandTotal = match ? match.totalCost : 0;
            } else {
                const mainPress = presses.find(p => p.name === selectedPress) || bestMainPress || null;
                const mainRunHours = mainPress ? qty / mainPress.piecesPerHour : 0;
                const mainRunCost = mainRunHours * (mainPress?.perHourCost || 0) * lab;

                const calcSpecialRun = (state) => state.state ? state.plates.reduce((sum, plate) => {
                    const press = plate.selectedPress || getBestPress(plate.pressWidth, plate.pressLength, false);
                    if (!press) return sum;
                    const hours = qty / press.piecesPerHour;
                    const passes = state === foil ? (plate.passes || 1) : 1;
                    return sum + hours * press.perHourCost * passes * lab;
                }, 0) : 0;

                const embossRun = calcSpecialRun(emboss);
                const debossRun = calcSpecialRun(deboss);
                const foilRun = calcSpecialRun(foil);

                const foilMaterial = foil.state ? foil.plates.reduce((sum, p) => {
                    if (!p.plateWidth || !p.plateLength) return sum;
                    const res = calculateFoilingCost({ quantity: qty }, p.plateLength, p.plateWidth);
                    return sum + (p.overrideFoilCost ?? res?.foil?.foilcost ?? 0);
                }, 0) : 0;

                const foilPlateAndMrCost = foil.state ? foil.plates.reduce((s, p) => s + (p.overridePlatecost ?? p.platecost), 0) + (foil.mr * lab * foil.plates.reduce((s, p) => s + (p.passes || 1), 0)) : 0;

                const embossSetup = emboss.state ? emboss.plates.reduce((s, p) =>
                    s + ((p.overridePlatecost ?? p.platecost) * mat) + ((p.overrideBacker ?? p.backer) * mat) + ((p.overrideMr ?? p.mr) * lab), 0) : 0;

                const debossSetup = deboss.state ? deboss.plates.reduce((s, p) =>
                    s + ((p.overridePlatecost ?? p.platecost) * mat) + ((p.overrideBacker ?? p.backer) * mat) + ((p.overrideMr ?? p.mr) * lab), 0) : 0;

                const dieTotal = dieCost * mat;
                const mrTotal = dieMr * lab;
                const stripTotal = stripping ? Math.ceil(qty / 1000) * 6 : 0;
                const foldingCost = foldingMode !== 'none' && foldingCount > 0
                    ? Math.ceil(totalPieces / 1000) * (foldingMode === 'hand' ? 20 : AUTO_FOLD_RATE) * foldingCount
                    : 0;

                const singleFoldCost = singleFoldCount > 0 ? (totalPieces * 0.01 * singleFoldCount) * lab : 0;
                const box1Cost = box1Count > 0 ? (totalPieces * 0.285 * box1Count) * lab : 0;
                const box2Cost = box2Count > 0 ? (totalPieces * 0.300 * box2Count) * lab : 0;

                const totalTabs = (pocketTabs.pocket1.numTabs || 0) +
                    (numPockets === 2 ? (pocketTabs.pocket2.numTabs || 0) : 0);

                let glueCost = 0;
                let glueLabel = '';

                if (glueTapingMode === 'auto') {
                    let totalInches = 0;
                    if (pocketTabs.pocket1.height > 0 && pocketTabs.pocket1.numTabs > 0) {
                        totalInches += pocketTabs.pocket1.height * pocketTabs.pocket1.numTabs;
                    }
                    if (numPockets === 2 && pocketTabs.pocket2.height > 0 && pocketTabs.pocket2.numTabs > 0) {
                        totalInches += pocketTabs.pocket2.height * pocketTabs.pocket2.numTabs;
                    }
                    const baseAutoGlueCost = totalInches > 0 ? (totalPieces / 1000) * totalInches * 0.01 * 1000 : 0;
                    glueCost = baseAutoGlueCost * mat;
                    glueLabel = totalInches > 0 ? `Auto Glue (${totalInches.toFixed(2)}" total)` : '';
                } else if (glueTapingMode === 'hand') {
                    const baseGlueCost = totalTabs > 0 ? totalPieces * 0.09 * totalTabs : 0;
                    glueCost = baseGlueCost * mat;
                    glueLabel = totalTabs > 0 ? `Hand Glue (${totalTabs} tab${totalTabs > 1 ? 's' : ''} @ $0.09/ea)` : '';
                } else if (glueTapingMode === 'taping') {
                    const baseTapingCost = totalTabs > 0 ? totalPieces * 0.13 * totalTabs : 0;
                    glueCost = baseTapingCost * mat;
                    glueLabel = totalTabs > 0 ? `Taping (${totalTabs} tab${totalTabs > 1 ? 's' : ''} @ $0.13/ea)` : '';
                }

                grandTotal = mainRunCost + embossRun + debossRun + foilRun + foilMaterial + foilPlateAndMrCost +
                    embossSetup + debossSetup + dieTotal + mrTotal + stripTotal +
                    foldingCost + boxesCost + singleFoldCost + box1Cost + box2Cost + glueCost;
            }

            return {
                ...q,
                pricePerUnit: parseFloat((grandTotal / qty).toFixed(4)),
                totalPrice: parseFloat(grandTotal.toFixed(2))
            };
        });

        const newItem = {
            id: editingItem?.id || Date.now(),
            type: 'finishing',
            width: Number(width),
            length: Number(length),
            numPockets,
            press: isStandard9x12With4InchPockets ? null : selectedPress,
            dieCost: dieCost === 0 ? null : dieCost,
            dieMr: dieMr === 0 ? 0 : dieMr,
            stripping,
            size: `${width}" x ${length}"`,
            singleFoldCount: Number(singleFoldCount) || 0,
            box1Count: Number(box1Count) || 0,
            box2Count: Number(box2Count) || 0,
            numUp: Number(numUp) || 1,
            boxRate: { rate: boxRate.rate, override: boxRate.override },
            foldingMode,
            folding: Number(foldingCount) || 0,
            glueTapingMode,
            labPercent: labPercent === 1.15 ? undefined : labPercent,
            matPercent: matPercent === 1.30 ? undefined : matPercent,
            emboss: emboss.state ? { ...emboss, plates: cleanPlates(emboss.plates) } : null,
            deboss: deboss.state ? { ...deboss, plates: cleanPlates(deboss.plates) } : null,
            foil: foil.state ? { ...foil, plates: cleanPlates(foil.plates) } : null,
            pocketTabs: {
                pocket1: {
                    height: Number(pocketTabs.pocket1.height) || 0,
                    numTabs: Number(pocketTabs.pocket1.numTabs) || 0
                },
                pocket2: numPockets === 2 ? {
                    height: Number(pocketTabs.pocket2.height) || 0,
                    numTabs: Number(pocketTabs.pocket2.numTabs) || 0
                } : null
            },
            quantities: quantitiesWithTotal.map(q => ({
                ...q,
                totalPieces: q.quantity * (Number(numUp) || 1)
            }))
        };

        setEstitems(prev => {
            const updated = editingItem
                ? prev.pocketfolder.map(i => i.id === editingItem.id ? newItem : i)
                : [...(prev.pocketfolder || []), newItem];
            return { ...prev, pocketfolder: updated };
        });
        closeModal();
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/70" style={{ zIndex: '15000' }}>
            <div className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-7xl mx-4 my-8 max-h-[90vh] overflow-y-auto p-8" style={{ padding: '20px' }}>
                <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
                    {editingItem ? 'Edit Finishing Item' : 'Add Finishing Item'}
                </h2>
                <div style={{ display: 'flex' }}>
                    <div><Label>Add Quantity (press Enter)</Label><Input ref={quanbox} width="300px" type="number" placeholder="1000, 2500..." onKeyDown={addquan} /></div>
                </div>
                <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', marginTop: '20px', flexWrap: 'wrap' }}>
                    <div>
                        <Label>Width (inches)</Label><br />
                        <NumInput width="120px" step="0.1" value={width} onChange={setWidth} placeholder="9" />
                    </div>
                    <div>
                        <Label>Length (inches)</Label><br />
                        <NumInput width="120px" step="0.1" value={length} onChange={setLength} placeholder="12" />
                    </div>
                    {!isStandard9x12With4InchPockets && (
                        <div style={{ minWidth: '300px' }}>
                            <Label>Press Machine</Label>
                            <select value={selectedPress} onChange={e => setSelectedPress(e.target.value)}
                                className={`w-full p-4 border-2 rounded-lg text-lg font-medium mt-2 ${selectedPress ? 'bg-green-50 border-green-500' : 'bg-red-50 border-red-500'}`}>
                                <option value="" disabled>{width && length ? 'Select press...' : 'Enter size first'}</option>
                                {presses.map(p => {
                                    const fits = [width, length, length, width].some((gw, i) => {
                                        const grip = i < 2 ? Number(width) : Number(length);
                                        const feed = i < 2 ? Number(length) : Number(width);
                                        return grip >= p.minWidth && grip <= p.maxWidth && feed >= p.minLength && feed <= p.maxLength;
                                    });
                                    const blocked = needsSpecialFinish && p.name.includes('Miller');
                                    return (
                                        <option key={p.name} value={p.name} >
                                            {p.name}{bestMainPress?.name === p.name ? ' (RECOMMENDED)' : ''}{blocked ? ' (No special finish)' : ''}
                                        </option>
                                    );
                                })}
                            </select>
                            {bestMainPress && !selectedPress && (
                                <p className="text-sm text-green-600 mt-2">Auto-selected: {bestMainPress.name}</p>
                            )}
                        </div>
                    )}
                    <div>
                        <Label>Pockets</Label><br />
                        <select value={numPockets} onChange={(e) => setNumPockets(Number(e.target.value))}
                            className="p-4 border-2 rounded-lg text-lg font-medium" style={{ width: "120px" }}>
                            <option value={1}>1 Pocket</option>
                            <option value={2}>2 Pockets</option>
                        </select>
                    </div>
                    <div><Label>Die Cost $</Label><br /><NumInput width="100px" step="0.01" value={dieCost} onChange={setDieCost} placeholder="0.00" /></div>
                    <div><span className="text-sm font-medium whitespace-nowrap">MR $</span><br /><NumInput value={dieMr} onChange={setDieMr} width="100px" /></div>
                </div>
                <div className="space-y-8">
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", justifyContent: "space-between", marginBottom: '20px', marginTop: '20px', gap: '20px' }}>
                        <div className="flex flex-col gap-4" style={{ marginRight: '16px' }}>
                            <div className="bg-gray-100 p-4 rounded-lg">
                                <strong className="block mb-2 text-sm font-bold text-gray-700">Pocket Tabs</strong>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <span className="text-sm font-medium">Pocket 1 Height (in)</span><br />
                                        <NumInput value={pocketTabs.pocket1.height} onChange={v => setPocketTabs(prev => ({
                                            ...prev,
                                            pocket1: { ...prev.pocket1, height: v }
                                        }))} step="0.1" min="0" width="100px" />
                                    </div>
                                    <div>
                                        <span className="text-sm font-medium">Pocket 1 Tabs</span><br />
                                        <NumInput value={pocketTabs.pocket1.numTabs} onChange={v => setPocketTabs(prev => ({
                                            ...prev,
                                            pocket1: { ...prev.pocket1, numTabs: Math.max(1, v || 1) }
                                        }))} min="1" width="100px" />
                                    </div>
                                    {numPockets === 2 && (
                                        <>
                                            <div>
                                                <span className="text-sm font-medium">Pocket 2 Height (in)</span><br />
                                                <NumInput value={pocketTabs.pocket2.height} onChange={v => setPocketTabs(prev => ({
                                                    ...prev,
                                                    pocket2: { ...prev.pocket2, height: v }
                                                }))} step="0.1" min="0" width="100px" />
                                            </div>
                                            <div>
                                                <span className="text-sm font-medium">Pocket 2 Tabs</span><br />
                                                <NumInput value={pocketTabs.pocket2.numTabs} onChange={v => setPocketTabs(prev => ({
                                                    ...prev,
                                                    pocket2: { ...prev.pocket2, numTabs: Math.max(1, v || 1) }
                                                }))} min="1" width="100px" />
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="mt-4">
                                    <span className="text-sm font-medium whitespace-nowrap">Glue / Taping Type</span><br />
                                    <select
                                        value={glueTapingMode}
                                        onChange={e => setGlueTapingMode(e.target.value)}
                                        className="w-full px-3 py-2 border rounded text-sm mt-1"
                                    >
                                        <option value="auto">Auto Glue</option>
                                        <option value="hand">Hand Glue</option>
                                        <option value="taping">Taping</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-wrap items-center gap-10" style={{ paddingTop: '15px' }}>
                            <div className="items-center gap-3">
                                <span className="text-sm font-medium whitespace-nowrap">Single Fold (#)</span><br />
                                <NumInput value={singleFoldCount} onChange={setSingleFoldCount} min="0" width="80px" placeholder="0" />
                            </div>
                            <div className="items-center gap-3">
                                <span className="text-sm font-medium whitespace-nowrap">1 Box (#)</span><br />
                                <NumInput value={box1Count} onChange={setBox1Count} min="0" width="80px" placeholder="0" />
                            </div>
                            <div className="items-center gap-3">
                                <span className="text-sm font-medium whitespace-nowrap">2 Box (#)</span><br />
                                <NumInput value={box2Count} onChange={setBox2Count} min="0" width="80px" placeholder="0" />
                            </div>
                            <div className="items-center"><span className="text-sm font-medium whitespace-nowrap">Num Up:</span><br /><NumInput value={numUp} onChange={setNumUp} min="1" width="100px" /></div>
                            <div><label className="flex items-center gap-3"><input type="checkbox" checked={stripping} onChange={e => setStripping(e.target.checked)} className="w-5 h-5" /><span>Stripping</span></label></div>
                            <div>
                                <span className="text-sm font-medium whitespace-nowrap">Boxes :</span><br />
                                <div className="flex items-center gap-2">
                                    <strong className={boxRate.override === null ? "text-green-600" : "text-orange-600"}>
                                        ${boxRate.override !== null ? boxRate.override.toFixed(2) : boxRate.rate.toFixed(2)}/k
                                    </strong>
                                    <NumInput
                                        value={boxRate.override ?? ''}
                                        onChange={(v) => setBoxRate(prev => ({ ...prev, override: v === '' || v === null ? null : parseFloat(v) }))}
                                        step="0.01"
                                        placeholder="Override rate"
                                        width="90px"
                                        className="text-orange-600 font-medium"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* EMBOSSING, DEBOSSING, FOIL STAMPING sections — unchanged, same as previous full version */}

                    {quantities.length > 0 && (
                        <div className="mt-10">
                            <h2 className="text-2xl font-bold text-gray-800 mb-5">Quantities & Pricing</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-6">
                                {quantities.map(item => {
                                    const qty = item.quantity;
                                    const totalPieces = qty * numUp;
                                    let mainRunCost = 0, embossRun = 0, debossRun = 0, foilRun = 0, foilMaterial = 0, foilPlateAndMrCost = 0;
                                    let embossSetup = 0, debossSetup = 0, dieTotal = 0, mrTotal = 0, stripTotal = 0;
                                    let foldingCost = 0, boxesCost = 0;
                                    let singleFoldCost = 0, box1Cost = 0, box2Cost = 0, glueCost = 0;
                                    let glueLabel = '';
                                    let grandTotal = 0;
                                    let boxesPerThousand = Math.ceil(totalPieces / 1000);
                                    let ratePerThousand = boxRate.override !== null ? boxRate.override : boxRate.rate;

                                    if (isStandard9x12With4InchPockets) {
                                        const match = standardtwopocket.find(m => m.quantity === qty);
                                        grandTotal = match ? match.totalCost : 0;
                                    } else {
                                        const mainPress = presses.find(p => p.name === selectedPress) || bestMainPress || null;
                                        const mainRunHours = mainPress ? qty / mainPress.piecesPerHour : 0;
                                        mainRunCost = mainRunHours * (mainPress?.perHourCost || 0) * lab;

                                        const calcSpecialRun = (state) => state.state ? state.plates.reduce((sum, plate) => {
                                            const press = plate.selectedPress || getBestPress(plate.pressWidth, plate.pressLength, false);
                                            if (!press) return sum;
                                            const hours = qty / press.piecesPerHour;
                                            const passes = state === foil ? (plate.passes || 1) : 1;
                                            return sum + hours * press.perHourCost * passes * lab;
                                        }, 0) : 0;

                                        embossRun = calcSpecialRun(emboss);
                                        debossRun = calcSpecialRun(deboss);
                                        foilRun = calcSpecialRun(foil);

                                        foilMaterial = foil.state ? foil.plates.reduce((sum, p) => {
                                            if (!p.plateWidth || !p.plateLength) return sum;
                                            const res = calculateFoilingCost({ quantity: qty }, p.plateLength, p.plateWidth);
                                            return sum + (p.overrideFoilCost ?? res?.foil?.foilcost ?? 0);
                                        }, 0) : 0;

                                        foilPlateAndMrCost = foil.state ? foil.plates.reduce((s, p) => s + (p.overridePlatecost ?? p.platecost), 0) + (foil.mr * lab * foil.plates.reduce((s, p) => s + (p.passes || 1), 0)) : 0;

                                        embossSetup = emboss.state ? emboss.plates.reduce((s, p) =>
                                            s + ((p.overridePlatecost ?? p.platecost) * mat) + ((p.overrideBacker ?? p.backer) * mat) + ((p.overrideMr ?? p.mr) * lab), 0) : 0;

                                        debossSetup = deboss.state ? deboss.plates.reduce((s, p) =>
                                            s + ((p.overridePlatecost ?? p.platecost) * mat) + ((p.overrideBacker ?? p.backer) * mat) + ((p.overrideMr ?? p.mr) * lab), 0) : 0;

                                        dieTotal = dieCost * mat;
                                        mrTotal = dieMr * lab;
                                        stripTotal = stripping ? Math.ceil(qty / 1000) * 6 : 0;
                                        foldingCost = foldingMode !== 'none' && foldingCount > 0
                                            ? Math.ceil(totalPieces / 1000) * (foldingMode === 'hand' ? 20 : AUTO_FOLD_RATE) * foldingCount
                                            : 0;
                                        boxesCost = boxesPerThousand * ratePerThousand;

                                        singleFoldCost = singleFoldCount > 0 ? (totalPieces * 0.01 * singleFoldCount) * lab : 0;
                                        box1Cost = box1Count > 0 ? (totalPieces * 0.285 * box1Count) * lab : 0;
                                        box2Cost = box2Count > 0 ? (totalPieces * 0.300 * box2Count) * lab : 0;

                                        const totalTabs = (pocketTabs.pocket1.numTabs || 0) +
                                            (numPockets === 2 ? (pocketTabs.pocket2.numTabs || 0) : 0);

                                        if (glueTapingMode === 'auto') {
                                            let totalInches = 0;
                                            if (pocketTabs.pocket1.height > 0 && pocketTabs.pocket1.numTabs > 0) {
                                                totalInches += pocketTabs.pocket1.height * pocketTabs.pocket1.numTabs;
                                            }
                                            if (numPockets === 2 && pocketTabs.pocket2.height > 0 && pocketTabs.pocket2.numTabs > 0) {
                                                totalInches += pocketTabs.pocket2.height * pocketTabs.pocket2.numTabs;
                                            }
                                            const baseAutoGlueCost = totalInches > 0 ? (totalPieces / 1000) * totalInches * 0.01 * 1000 : 0;
                                            glueCost = baseAutoGlueCost * mat;
                                            glueLabel = totalInches > 0 ? `Auto Glue (${totalInches.toFixed(2)}" total)` : '';
                                        } else if (glueTapingMode === 'hand') {
                                            const baseGlueCost = totalTabs > 0 ? totalPieces * 0.09 * totalTabs : 0;
                                            glueCost = baseGlueCost * mat;
                                            glueLabel = totalTabs > 0 ? `Hand Glue (${totalTabs} tab${totalTabs > 1 ? 's' : ''} @ $0.09/ea)` : '';
                                        } else if (glueTapingMode === 'taping') {
                                            const baseTapingCost = totalTabs > 0 ? totalPieces * 0.13 * totalTabs : 0;
                                            glueCost = baseTapingCost * mat;
                                            glueLabel = totalTabs > 0 ? `Taping (${totalTabs} tab${totalTabs > 1 ? 's' : ''} @ $0.13/ea)` : '';
                                        }

                                        grandTotal = mainRunCost + embossRun + debossRun + foilRun + foilMaterial + foilPlateAndMrCost +
                                            embossSetup + debossSetup + dieTotal + mrTotal + stripTotal +
                                            foldingCost + boxesCost + singleFoldCost + box1Cost + box2Cost + glueCost;
                                    }

                                    return (
                                        <div key={item.quantity} className="border rounded-xl p-5 bg-white shadow-lg relative" style={{ padding: '10px' }}>
                                            <button onClick={() => removeQuantity(item.quantity)} className="absolute top-2 right-2 bg-red-500 text-white w-7 h-7 rounded-full text-sm">X</button>
                                            <div className="text-2xl font-bold text-blue-700">{item.quantity.toLocaleString()}</div>
                                            {isStandard9x12With4InchPockets && <div className="text-green-600 font-bold text-sm mb-2">Standard 9x12 4" Pocket Pricing</div>}
                                            <div className="text-sm text-gray-600">{selectedPress || (bestMainPress?.name || 'No press')}</div>
                                            <div className="mt-4 space-y-1 text-sm">
                                                {!isStandard9x12With4InchPockets && mainRunCost > 0 && <div className="flex justify-between"><span>Machine Run:</span><strong>${mainRunCost.toFixed(2)}</strong></div>}
                                                {embossRun > 0 && <div className="flex justify-between text-purple-600"><span>Emboss Run:</span><strong>${embossRun.toFixed(2)}</strong></div>}
                                                {debossRun > 0 && <div className="flex justify-between text-red-600"><span>Deboss Run:</span><strong>${debossRun.toFixed(2)}</strong></div>}
                                                {foilRun > 0 && <div className="flex justify-between text-amber-700"><span>Foil Run:</span><strong>${foilRun.toFixed(2)}</strong></div>}
                                                {foilMaterial > 0 && <div className="flex justify-between text-amber-600"><span>Foil Material:</span><strong>${foilMaterial.toFixed(2)}</strong></div>}
                                                {foilPlateAndMrCost > 0 && <div className="flex justify-between text-amber-600"><span>Foil Plates + MR:</span><strong>${foilPlateAndMrCost.toFixed(2)}</strong></div>}
                                                {embossSetup > 0 && <div className="flex justify-between text-blue-600"><span>Emboss Setup:</span><strong>${embossSetup.toFixed(2)}</strong></div>}
                                                {debossSetup > 0 && <div className="flex justify-between text-red-600"><span>Deboss Setup:</span><strong>${debossSetup.toFixed(2)}</strong></div>}
                                                {dieTotal > 0 && <div className="flex justify-between"><span>Die:</span><strong>${dieTotal.toFixed(2)}</strong></div>}
                                                {mrTotal > 0 && <div className="flex justify-between"><span>MR:</span><strong>${mrTotal.toFixed(2)}</strong></div>}
                                                {stripTotal > 0 && <div className="flex justify-between"><span>Stripping:</span><strong>${stripTotal.toFixed(2)}</strong></div>}
                                                {foldingCost > 0 && <div className="flex justify-between text-indigo-600"><span>{foldingMode === 'hand' ? 'Hand' : 'Auto'} Folding:</span><strong>${foldingCost.toFixed(2)}</strong></div>}
                                                {boxesCost > 0 && <div className="flex justify-between text-orange-600 font-medium"><span>Boxes ({boxesPerThousand} × ${ratePerThousand.toFixed(2)}/k):</span><strong>${boxesCost.toFixed(2)}</strong></div>}
                                                {singleFoldCount > 0 && singleFoldCost > 0 && <div className="flex justify-between text-teal-600"><span>Single Fold ({singleFoldCount} @ $0.01/ea):</span><strong>${singleFoldCost.toFixed(2)}</strong></div>}
                                                {box1Count > 0 && box1Cost > 0 && <div className="flex justify-between text-teal-600"><span>1 Box ({box1Count} @ $0.285/ea):</span><strong>${box1Cost.toFixed(2)}</strong></div>}
                                                {box2Count > 0 && box2Cost > 0 && <div className="flex justify-between text-teal-600"><span>2 Box ({box2Count} @ $0.300/ea):</span><strong>${box2Cost.toFixed(2)}</strong></div>}
                                                {glueCost > 0 && glueLabel && (
                                                    <div className="flex justify-between text-teal-600">
                                                        <span>{glueLabel}:</span>
                                                        <strong>${glueCost.toFixed(2)}</strong>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="border-t-2 border-gray-300 my-3"></div>
                                            <div className="text-xl font-bold text-green-600">Total: ${grandTotal.toFixed(2)}</div>
                                            <div className="text-lg font-bold text-green-600">Total Pieces: {(qty * numUp).toLocaleString()}</div>
                                            <div className="text-sm text-gray-600">${(grandTotal / qty).toFixed(4)}/unit</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    <div className="mt-12 flex justify-end gap-4" style={{ marginTop: '30px' }}>
                        <Button onClick={handleSubmit} disabled={quantities.length === 0} className="px-10 py-4 text-xl font-bold bg-blue-600 hover:bg-blue-700 text-white">
                            {editingItem ? 'Update Item' : 'Add to Estimate'}
                        </Button>
                        <Button onClick={closeModal} variant="secondary" className="px-8 py-4 text-xl">Cancel</Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PocketFolder;